import {
  extractStoreHeader,
  extractBearerHeader,

  // removeInternalParams,
} from '@/api/helpers';

const request = {
  success(config) {
    // removeInternalParams(config);
    extractBearerHeader(config);

    // if (config.url.match(process.env.VUE_APP_BANKS_API_SUFFIX)) {
    extractStoreHeader(config);
    // }

    return config;
  },
  error(error) {
    return Promise.reject(error);
  },
};

const response = {
  success(res) {
    return res;
  },
  error(error) {
    if (error.response && [401, 403].includes(error.response.status)) {
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }

    return Promise.reject(error);
  },
};

export default {
  request,
  response,
};
